import React from 'react';
import DropdownReportOption from '../../../container/dropdown/dropdown-report-create/DropdownReportOption';
import DateRangePickerWithCalendar from '../../calendar/DateRangePickerWithCalendar';
import './TrendDetail.css';

const DateIndicator = (props) => {
  const activeStyle = {
    background: "#BEB4FF",
    color: "#ffffff"
  }
  if (props.onDateBtn == "w1") {
    return (
      <>
        <a className="button option" style={activeStyle} name="1week" onClick={(e) => props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e) => props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e) => props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e) => props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else if (props.onDateBtn == "w2") {
    return (
      <>
        <a className="button option" name="1week" onClick={(e) => props.handleDateBtn(e)}>1W</a>
        <a className="button option" style={activeStyle} name="2week" onClick={(e) => props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e) => props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e) => props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else if (props.onDateBtn == "m1") {
    return (
      <>
        <a className="button option" name="1week" onClick={(e) => props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e) => props.handleDateBtn(e)}>2W</a>
        <a className="button option" style={activeStyle} name="1month" onClick={(e) => props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e) => props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else if (props.onDateBtn == "m3") {
    return (
      <>
        <a className="button option" name="1week" onClick={(e) => props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e) => props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e) => props.handleDateBtn(e)}>1M</a>
        <a className="button option" style={activeStyle} name="3month" onClick={(e) => props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else {
    return (
      <>
        <a className="button option" name="1week" onClick={(e) => props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e) => props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e) => props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e) => props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
}

const TimeUnitIndicator = (props) => {
  const activeStyle = {
    background: "#BEB4FF",
    color: "#ffffff"
  }
  if (props.onTimeUnitBtn == "daily") {
    return (
      <>
        <a className="button option" style={activeStyle} name="daily" onClick={(e) => props.handleTimeUnitBtn(e)}>일간</a>
        <a className="button option" name="weekly" onClick={(e) => props.handleTimeUnitBtn(e)}>주간</a>
        <a className="button option" name="monthly" onClick={(e) => props.handleTimeUnitBtn(e)}>월간</a>
      </>
    )
  }
  else if (props.onTimeUnitBtn == "weekly") {
    return (
      <>
        <a className="button option" name="daily" onClick={(e) => props.handleTimeUnitBtn(e)}>일간</a>
        <a className="button option" style={activeStyle} name="weekly" onClick={(e) => props.handleTimeUnitBtn(e)}>주간</a>
        <a className="button option" name="monthly" onClick={(e) => props.handleTimeUnitBtn(e)}>월간</a>
      </>
    )
  }
  else if (props.onTimeUnitBtn == "monthly") {
    return (
      <>
        <a className="button option" name="daily" onClick={(e) => props.handleTimeUnitBtn(e)}>일간</a>
        <a className="button option" name="weekly" onClick={(e) => props.handleTimeUnitBtn(e)}>주간</a>
        <a className="button option" style={activeStyle} name="monthly" onClick={(e) => props.handleTimeUnitBtn(e)}>월간</a>
      </>
    )
  }
  else {
    return (
      <>
        <a className="button option" name="daily" onClick={(e) => props.handleTimeUnitBtn(e)}>일간</a>
        <a className="button option" name="weekly" onClick={(e) => props.handleTimeUnitBtn(e)}>주간</a>
        <a className="button option" name="monthly" onClick={(e) => props.handleTimeUnitBtn(e)}>월간</a>
      </>
    )
  }
}


const TrendVolumeOptionBar = (props) => {
  const handleKeyPress = (e) => {
    // Enter 키를 눌렀을 때의 동작을 정의합니다.
    if (e.key === 'Enter') {
      e.preventDefault(); // 기본 줄바꿈 동작을 막습니다.
      // props.handleRunBtn(); // '실행' 버튼의 기능을 호출합니다.
    }
  };

  const MAX_QUERIES = 5;

  return (
    <>
      <div className="reportTopBg" style={{ height: '100%' }}>
        <div className="settingBox">
          <div className="analysis_indicator">
            <div className="indicator-box">
              날짜 <DateIndicator handleDateBtn={props.handleDateBtn} onDateBtn={props.onDateBtn} />
              &nbsp;&nbsp;<DropdownReportOption img="calendar" >
                <DateRangePickerWithCalendar authed={true} minDate={props.minDate} value={props.dateRange} onChange={props.handleDate} />
              </DropdownReportOption>
            </div>
            <div className="indicator-box" style={{ display: "inline-flex", alignItems: "flex-start" }}>
              <span style={{ paddingLeft: "30px", width: '80px', marginTop: '10px' }}>주제어&nbsp;&nbsp;</span>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                {props.trendQueries.map((query, index) => (
                  <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <textarea
                      value={query}
                      onChange={(e) => props.handleQueryChange(index, e)}
                      onKeyDown={handleKeyPress}
                      rows="1"
                      cols="15"
                      placeholder="주제어 입력"
                      style={{ width: '100%', maxWidth: '400px', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', resize: 'none' }}
                    />
                    {props.trendQueries.length > 1 && (
                      <button className="button option" onClick={() => props.handleRemoveQuery(index)} style={{ padding: '0 10px', width: '15px' }}>
                        -
                      </button>
                    )}
                    {index === props.trendQueries.length - 1 && props.trendQueries.length < MAX_QUERIES && (
                      <button className="button option" onClick={props.handleAddQuery} style={{ padding: '0 10px', width: '15px' }}>
                        +
                      </button>
                    )}
                    {/* {index === props.trendQueries.length - 1 && (
                      <button className="button option" onClick={props.handleAddQuery} style={{ padding: '0 10px', width: '15px' }}>
                        +
                      </button>
                    )} */}
                  </div>
                ))}
              </div>
            </div>
            <div className="indicator-box">
              <span style={{ paddingLeft: "30px" }}>Time Unit <TimeUnitIndicator handleTimeUnitBtn={props.handleTimeUnitBtn} onTimeUnitBtn={props.onTimeUnitBtn} /></span>
            </div>
          </div>
          <hr style={{ height: "1px", border: "0 none", color: "#ccc", backgroundColor: "#e3e3e3", margin: "7.5px" }} />
        </div>
        <div className="settingBtn">
          <a className="button purple" onClick={() => props.handleRunBtn()}>실행</a>&nbsp;
        </div>
      </div>
    </>
  )
}

export default TrendVolumeOptionBar;